import { Layout } from '@enterprise-ui/canvas-ui-react'
import { useAuth } from '@praxis/component-auth'
import { NavLink, useLocation } from 'react-router-dom'
import { SideNavigation, Header } from 'item-component'
import { MainRouter } from '../globalComponents/MainRouter'
import { LogIn } from './common/LogIn'
import { Unauthorized } from './common/Unauthorized'
import { LoadingProfile } from './common/LoadingProfile'
import { useMain } from './useMain'
import Banner from './common/Banner'
import { isItemhubDomain } from '../globalUtils/searchUtills'
import apiConfig from '../globalConfig/apiConfig'

export const Main = () => {
  const {
    loading,
    error,
    data,
    constructedMenu,
    constructDynamicMenu,
    bannerHeader,
    getUserProfile,
    canUserBulk,
  } = useMain()

  const location = useLocation()
  const path =
    typeof window !== 'undefined' && window.location?.pathname
      ? window.location.pathname
      : location?.pathname || '/'

  const appMenus = constructedMenu(isItemhubDomain)
  const dynamicMenus = isItemhubDomain ? constructDynamicMenu() : null
  const auth = useAuth()
  const { isAuthenticated } = auth
  const bannerData = bannerHeader ? bannerHeader?.bannerDetail : []

  if (isAuthenticated()) {
    if (loading) return <LoadingProfile />
    if (error) return <Unauthorized />
    if (data) {
      return (
        <Layout
          theme="dark" // configure theme here
          darkMode="false" // configure theme here
          data-testid="mainAuthenticatedLayout"
        >
          <>
            {bannerData &&
              bannerData.map((banner, index) => {
                return <Banner key={index} bannerData={banner} />
              })}
            <Header
              userRole={
                getUserProfile?.roles ? getUserProfile.roles?.join() : ''
              }
              useAuth={useAuth}
              appTitle={isItemhubDomain ? 'ItemHub' : 'Launchpad'}
              isSupportVisible={true}
            />
            {getUserProfile?.roles?.length > 0 && (
              <SideNavigation
                className="side-navigation-panel"
                data-testid="item-app-sidenav-panel"
                appMenus={appMenus}
                defaultmenurequired={isItemhubDomain}
                isMinimized={!isItemhubDomain}
                itemHubApiKey={apiConfig?.itemhubappservice?.apiKey}
                clientApp={'lp-search'}
                dynamicMenus={dynamicMenus}
                LinkComponent={NavLink} // Pass link component
                currentPath={path} //Pass current route path
              />
            )}
          </>
          <MainRouter
            getUserProfile={getUserProfile}
            canUserBulk={canUserBulk}
          />
        </Layout>
      )
    }
  } else {
    return <LogIn />
  }
}
